import Vue from 'vue'
import App from './App.vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

Vue.config.productionTip = false

import Intro from './components/Intro.vue'
import Vrijmetselarij from './components/Vrijmetselarij.vue'
import OverDeLoge from './components/OverDeLoge.vue'
import Werktafel from './components/Werktafel'
import ArtikelenIndex from './components/ArtikelenIndex'
import Artikel from './components/Artikel'
import Informatie from './components/Informatie'

const routes = [
  { path: '/', component: Intro },
  { path: '/vrijmetselarij', component: Vrijmetselarij },
  { path: '/over-onze-loge', component: OverDeLoge },
  { path: '/werktafel', component: Werktafel },
  { path: '/artikelen', component: ArtikelenIndex },
  { path: '/artikelen/:id', component: Artikel, props: true },
  { path: '/informatie', component: Informatie }
]

const router = new VueRouter({
    mode: 'hash',
  routes
})

new Vue({
    router,
  render: h => h(App),
  components: {
      Intro
  }
}).$mount('#app')
